import {
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
} from 'components/ModalV2/Modal'
import { ColorVariant, Flex } from 'styling/GlobalStyles'
import { Heading2, NormalText, SmallText } from 'styling/TypographyV2'
import { CloseIcon } from 'assets/icons/CloseIcon'

interface ITeamHistoryEntry {
  id: number
  date: string
  action: string
  actor: string
  details: string
}

const TEAM_HISTORY: ITeamHistoryEntry[] = [
  {
    id: 1,
    date: '09/06/2026 14:32',
    action: 'Member assigned',
    actor: 'Sarah Chen',
    details: 'James Mitchell added to team',
  },
  {
    id: 2,
    date: '08/06/2026 09:15',
    action: 'Supervisor updated',
    actor: 'David Okafor',
    details: 'Escalation chain revised',
  },
  {
    id: 3,
    date: '05/06/2026 16:40',
    action: 'Member removed',
    actor: 'Marcus Owen',
    details: 'Ethan Walker assignment ended',
  },
  {
    id: 4,
    date: '01/06/2026 11:00',
    action: 'Team created',
    actor: 'Sarah Chen',
    details: 'Initial team setup at North Pit',
  },
]

interface TeamHistoryModalProps {
  teamName: string
  onClose: () => void
}

export const TeamHistoryModal = ({ teamName, onClose }: TeamHistoryModalProps) => (
  <Modal onClose={onClose}>
    <ModalContent maxWidth='640px'>
      <ModalHeader>
        <Flex between center width='100%'>
          <Heading2>Team history · {teamName}</Heading2>
          <CloseIcon onClick={onClose} />
        </Flex>
      </ModalHeader>
      <ModalBody>
        <NormalText colorVariant={ColorVariant.SECONDARY}>
          Assignment and configuration changes for this team.
        </NormalText>
        {TEAM_HISTORY.map((entry) => (
          <div key={entry.id} style={{ padding: '0.875rem 0', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
            <NormalText semibold colorVariant={ColorVariant.BASE}>{entry.action}</NormalText>
            <SmallText colorVariant={ColorVariant.SECONDARY} mt='0.25rem'>
              {entry.details}
            </SmallText>
            <SmallText colorVariant={ColorVariant.SECONDARY} mt='0.25rem'>
              {entry.date} · {entry.actor}
            </SmallText>
          </div>
        ))}
      </ModalBody>
    </ModalContent>
  </Modal>
)
